module.exports = __webpack_public_path__ + "static/img/bz1.a62eebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/bz1.png
// module id = 304
// module chunks = 0